import { render, staticRenderFns } from "./tempPergGajiAnjakan.vue?vue&type=template&id=71cfcb20&"
import script from "./tempPergGajiAnjakan.vue?vue&type=script&lang=js&"
export * from "./tempPergGajiAnjakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports